import { SearchComponenet } from '@/components/GlobalSearch/SearchComponenet';
import { AuthContext } from '@/components/Contexts/AuthContext';
import { useContext, useState } from 'react';
import { useMobile } from '@/util';
import { Dropdown, PersonAvatar, Button } from '@teo/components';
import { NotificationButton } from '@/components/Notifications/NotificationButton';
import i18n from 'i18next';
import { useTranslation } from 'react-i18next';
import { logout } from '@/services/logout.service.js';
import { Link } from 'react-router-dom';

const LearningPathHeader = ({ activeSearch, setActiveSearch }) => {
  const { t } = useTranslation();
  const { auth } = useContext(AuthContext);
  const authUser = auth?.user;
  const isMobile = useMobile();

  return (
    <header className=" flex h-[80px] min-h-16 items-center justify-start border-b border-solid border-grey-02 bg-white px-3 py-4">
      <Link to={'/learn'} className="mr-14 w-12">
        <img src="/images/TEO_logo.svg" />
      </Link>
      <>
        {authUser.activeOrganisationRole &&
          authUser?.activeOrganisationRole > 10 && (
            <SearchComponenet
              isMobile={isMobile}
              activeSearch={activeSearch}
              setActiveSearch={setActiveSearch}
            />
          )}
      </>
      {authUser && (
        <div className={`ml-auto flex flex-row items-center gap-4`}>
          <NotificationButton />
          {!isMobile && (
            <div>
              <Dropdown>
                <Dropdown.Trigger>
                  <PersonAvatar
                    id={authUser.id}
                    name={authUser.username}
                    imageSrc={authUser.picture || undefined}
                  />
                </Dropdown.Trigger>
                <Dropdown.Content>
                  <Dropdown.Section className="flex items-center gap-3">
                    <PersonAvatar
                      id={authUser.id}
                      name={authUser.username}
                      imageSrc={authUser.picture || undefined}
                    />
                    {authUser?.username}
                  </Dropdown.Section>
                  <Dropdown.Actions>
                    <Dropdown.Link
                      to={'/' + i18n.language + '/profile/details'}
                    >
                      {t('links.profile')}
                    </Dropdown.Link>
                    <Dropdown.ExternalLink
                      href={t('external_links.help')}
                      target="_blank"
                    >
                      {t('links.help')}
                    </Dropdown.ExternalLink>
                    <Dropdown.Button
                      onClick={() => {
                        logout();
                      }}
                    >
                      {t('links.logout')}
                    </Dropdown.Button>
                  </Dropdown.Actions>
                </Dropdown.Content>
              </Dropdown>
            </div>
          )}
        </div>
      )}
    </header>
  );
};

export default LearningPathHeader;
